import React from 'react';

import { useReactNodeView } from '@lyearn/lygo-core';

import CheckListItemEditable from './CheckListItemEditable';
import CheckListItemReadOnly from './CheckListItemReadOnly';

const CheckListItemNodeView: React.FC = () => {
  const { view } = useReactNodeView();

  if (!view?.editable) {
    return <CheckListItemReadOnly />;
  }

  return <CheckListItemEditable />;
};

export default CheckListItemNodeView;
